export function getImageAlt(imageUrl: string, imageTitle: string) {
  if (!imageUrl) {
    return imageTitle;
  }

  try {
    const splittedImageUrl = imageUrl.split(".");
    const updatedImageUrl = splittedImageUrl[splittedImageUrl.length - 2];
    const imageTitleSplit = updatedImageUrl.split("-")?.pop();
    return `${imageTitle} ${imageTitleSplit}`;
  } catch (err) {
    return imageTitle;
  }
}
